import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import './theme/base.scss';

import { store } from './store/configureStore';
import App from './App';
import { unregister } from './registerServiceWorker';
import { Auth0Provider } from './Auth';
import { config } from './config';


// MUI Theme
const theme = createTheme({
  typography: {
    fontFamily: ['Heebo', 'sans-serif'].join(','),
  },
  palette: {
    primary: {
      light: '#5873a3',
      main: '#243141',
    },
    error: {
      main: '#dc3545',
    },
  },
});

// Auth0 Redirect
const onRedirectCallback = () => {
  window.history.replaceState({}, document.title, config.welcomeRoute);
};

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={config.domain}
      client_id={config.clientId}
      redirect_uri={config.redirectUri}
      audience={config.audience}
      onRedirectCallback={onRedirectCallback}
    >
      <Provider store={store}>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </Auth0Provider>
  </React.StrictMode>
);

unregister();
